<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select class="filter-item__select" v-model="querytype" @change="getStockDays">
          <option :value="'全部'">全部</option>
          <option :value="'物料'">物料</option>
        </select>
      </span>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box" v-if="querytype == '全部'">
      <div class="list-box-col">
        <p class="list-box-col__title">月份</p>
        <p class="list-box-col__content" v-for="item in result.monthitems" :key="item.text">{{ item.text }}</p>
        <!-- <p class="list-box-col__content">本年累计</p> -->
      </div>
      <div class="list-box-col list-box-active">
        <p class="list-box-col__title">平均库存天数</p>
        <p class="list-box-col__content" style="color: #2eadf5;" v-for="item in result.monthitems" :key="item.text">{{ item.amount || 0 }}</p>
      </div>
    </div>

    <div class="list-cells" v-if="querytype == '物料'">
      <div
        class="list-cell"
        v-for="(item, index) in result.details"
        :key="index"
      >
        <div class="list-cell__main" @click="open('opened', index)">
          <div class="list-cell__index"><span>{{ index + 1 }}</span></div>
          <div class="list-cell__content">{{ item.pr_code }} {{ item.pr_detail }}</div>
          <div class="list-cell__toggle">
            <span v-if="opened == index"><i class="iconfont icon-shang"></i></span>
            <span v-else><i class="iconfont icon-xia"></i></span>
          </div>
        </div>
        <div class="weui-cells" v-if="opened == index">
          <div class="weui-cell gray" v-for="(monthitem, index) in result.monthitems" :key="monthitem.text">
            <div class="weui-cell__bd">{{ monthitem.text }}</div>
            <div class="weui-cell__ft">{{ item['days' + ++index] }}</div>
          </div>
          <!-- <div class="weui-cell gray">
            <div class="weui-cell__bd">本月累计</div>
            <div class="weui-cell__ft">{{ item.amount }}</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import F2 from '@antv/f2/lib/index';
import ScrollBar from '@antv/f2/lib/plugin/scroll-bar';
import '@antv/f2/lib/interaction/pan';

export default {
  data() {
    let year = new Date().getFullYear()

    return {
      result: {},
      year,
      querytype: '全部',
      querytypeObj: {
        全部: 'all',
        物料: 'prod'
      },
      opened: -1,
      chart: null,
    };
  },
  mounted() {
    this.getStockDays()
  },
  methods: {
    getStockDays() {
      let me = this

      const params = {
        year: me.year,
        mode: me.querytypeObj[me.querytype]
      }

      me.$ajax({
        url: "/api/storage/report/getStockDays",
        params
      }).then(function (res) {
        if (res.success) {
          me.result = res.data
          me.initChart(me.deal(me.result.monthitems))
        }
      });
    },
    initChart(data) {
      let el = this.$el.querySelector(".myChart");
      el.style.width = "100%";
      el.style.height = "300px";
      
       // 初始化图表
       if (this.chart) {
        this.chart.clear();
      } else {
        this.chart = new F2.Chart({
          id: "myChart",
          pixelRatio: window.devicePixelRatio,
          plugins: ScrollBar,
        });
      }

      this.chart.source(data, {
        month: {
          min: 0,
          max: 7,
          tickInterval: 1,
          formatter: function(i) {
            return data[i-1]?.text || ''
          }
        }
      });

      // antv-f2柱状图平移，靠后的数据项未正确显示，先渲染一遍折线图
      this.chart.line().position('month*amount').style({
        lineWidth: 1   //设置折线的粗细为0
      })

      this.chart.point().position('month*amount');

      data.forEach((item) => {
        if(item.amount) {
          this.chart.guide().text({
            position: [ item.month, item.amount ],
            content: item.amount,
            style: {
              fill: '#808080',
              textAlign: 'center'
            },
            offsetY: -15
          })
        }
      })

      this.chart.interaction('pan');
      // 定义进度条
      this.chart.scrollBar({
        mode: 'x',
        xStyle: {
          backgroundColor: '#e8e8e8',
          fillerColor: '#808080',
          offsetY: -2
        }
      });

      this.chart.render();
    },
    deal(data) {
      data.forEach((item, index) => {
        item.month = ++index
      })

      return data
    },
    deal2(data) {
      if(!data) return

      const textArr = ["01月", "02月", "03月", "04月", "05月", "06月", "07月", "08月", "09月", "10月", "11月", "12月"]

      let arr = []

      textArr.forEach((text, month) => {
        arr[month] = {
          amount: data['days' + (month+1)] || 0,
          month: month + 1,
          text
        }
      });

      return arr
    },
    open(opened, index) {
      if(index != this[opened]) this.initChart(this.deal2(this.result.details[index]))

      this[opened] = index == this[opened] ? -1 : index
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = []
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      me.$weui.picker(
        years,
        {
          title: "选择年份",
          defaultValue: [year],
          onConfirm: function (r) {
            me.year = r[0].value
            me.getStockDays()
          },
        }
      );
    }
  }
};
</script>

<style scoped>
.canvas-box {
  /* width: 200%; */
  overflow-x: scroll;
  /* height: 100%; */
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option{
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
}
.list-box-col {
  text-align: center;
}
.list-box-col p {
  line-height: 40px;
}
.list-box-col__title {
  font-weight: bold;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}
.list-box-active:active {
  background: #e0e0e0;
}

.list-cells {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 56px;
  line-height: 56px;
  font-size: 12px;
  color: #8b8b8b;
  
  white-space:nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__ft {
  color: var(--weui-FG-1);
  font-size: 14px;
  line-height: 56px;
  padding: 0 5px;
}
.list-cell__toggle {
  width: 20px;
  height: 56px;
  line-height: 56px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  padding: 0 5px;
}
.gray {
  background: #f4f4f4;
}
</style>